import Resource from './Resource';

/**
 * Calendar Resource
 */
class Calendar extends Resource
{
    constructor() {
        super('calendar', ['calendars']);
    }

    weeklySlots(id, type, params = {}) {
      return this._doGet([id, 'slots', type, 'weekly'], params);
    }

    dailySlots(id, type, params = {}) {
      return this._doGet([id, 'slots', type, 'daily'], params);
    }
}   

/**
 * Calendar Entries Resource
 */
class CalendarEntry extends Resource
{
    constructor() {
        super('calendar.entry', ['calendars', ':id:', 'entries']);
    }

    forCalendar(id) {
        this.resourceSegments[1] = id;

        return this;
    }

    types(params = {}) {
        return this._doGet(['types'], params);
    }
}   
export let CalendarEntryResource = new CalendarEntry();

/**
 * Calendar Schema
 * @param {Object} defaults [description]
 */
export let CalendarSchema = function(defaults = {}) {
    let schema = {
        id: null,
        name: null,
        team_id: null,
        timeslot_strategy: {},
    };

    if (defaults) {
        schema = Object.assign(schema, defaults);
    }

   return schema;
};

export let CalendarEntryTypeSchema = function(defaults = {}) {
    let schema = {
        name: null,
        handle: null,
        calendar_id: null,
        timeslot_strategy: null,
    }

    if (defaults) {
        schema = Object.assign(schema, defaults);
    }

    return schema;
}

export let CalendarEntrySchema = function(defaults = {}) {
    let schema = {
        id: null,
        calendar_id: null, 
        calendar_entry_type_id: null,
        from: null, 
        to: null, 
        description: null, 
        created_by_id: null,
    }

    if (defaults) {
        schema = Object.assign(schema, defaults);
    }

    return schema;
}

export let TimeslotSchema = function(defaults = {}) {
    let schema = {
        title: null,
        from: null,
        to: null,
        available: null,
        total: null,
    }

    if (defaults) {
        schema = Object.assign(schema, defaults);
    }

    return schema;
}

export let TimeslotStrategies = {
    HOURLY: 'Marque\\Support\\Timeslots\\Strategies\\Hourly',
    DAILY: 'Marque\\Support\\Timeslots\\Strategies\\Daily'
};

export let CalendarResource = new Calendar();